import { WallMonitorCalibrationModel } from './wall-monitor-calibration.type';

export class WallCalibrationModel {
    constructor(
        public Width: number,
        public Height: number,
        public Monitors: WallMonitorCalibrationModel[],
        public IsCalibrated: boolean,
        public WallIndex?: number
    ) { }
}
